import { SIDE_DRAWER_CHILDREN_ROUTES } from "../../constants/routes";
import SideDrawerItemLabel from "../../components/SideDrawer/SideDrawerItemLabel/SideDrawerItemLabel";

export const SideDrawerRoles = (route, sideDrawerItemsCounts, moduleList) => {
  return {
    ...route,
    label: (
      <SideDrawerItemLabel
        route={route}
        sideDrawerItemCount={sideDrawerItemsCounts?.[route.path]}
      />
    ),

    children: SIDE_DRAWER_CHILDREN_ROUTES[route.key]
      ?.filter((route) =>
        moduleList.some(
          (item) =>
            item.children.length > 0 && item.children.includes(route.key)
        )
      )
      .map((route) => {
        return {
          key: route.path,
          icon: route.icon,
          label: (
            <SideDrawerItemLabel
              route={route}
              sideDrawerItemCount={sideDrawerItemsCounts?.[route.path]}
            />
          ),
        };
      }),
  };
};
